'use strict';

var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');
var Review = module.exports = SoaModel.extend();
var Notes = require('bunsen/collections/Notes');

var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var transitionMixin = require('bunsen/models/mixins/ecomm/transitionMixin');

_.extend(Review, {
    STATUS_PENDING: 'PENDING',
    STATUS_APPROVED: 'APPROVED',
    STATUS_REJECTED: 'REJECTED',
    STATUS_CANCELED: 'CANCELED',
    TYPE_FRAUD: 'FRAUD',
    TYPE_PAYMENT_DECLINED: 'PAYMENT_DECLINED',
    TYPE_SHIPPING_REQUEST: 'SPECIAL_SHIPMENT_INSTRUCTIONS'
});

_.extend(Review.prototype, {
    defaults: {
        apiType: 'review'
    },
    url: function () {
        return endpoints.review(this.id);
    },
    getShippingRequestNote: function () {
        var notes = this.get('notes');
        if (notes) {
            return notes.find(function (note) {
                return note.get('type') === 'SPECIAL_SHIPMENT_INSTRUCTIONS';
            });
        }
    },
    isPending: function() {
        return this.get('status') === Review.STATUS_PENDING;
    },
    isFraud: function() {
        return this.get('type') === Review.TYPE_FRAUD;
    },
    isPaymentDeclined: function() {
        return this.get('type') === Review.TYPE_PAYMENT_DECLINED;
    },
    transitionToPending: function () {
        return this.transition(Review.STATUS_PENDING);
    },
    approve: function() {
        return this.transition(Review.STATUS_APPROVED);
    },
    reject: function() {
        return this.transition(Review.STATUS_REJECTED);
    },
    relations: function () {
        return SoaModel.createRelations([
            {
                type : Backbone.Many,
                key : 'notes',
                collectionType: Notes
            }
        ]);
    }
}, transitionMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Review.js
// module id = 82
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54